import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer8GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Игрок 3"
        attackSignal="random3_attack"
        healSignal="random3_heal"
        attackDescription="Четыре бомбы падают с разных сторон и взрываются крестом. Урон 10."
        healDescription="Бомба."
    />
);
